import { render, staticRenderFns } from "./SelectionTypeDossierModal.vue?vue&type=template&id=3be0629a&"
import script from "./SelectionTypeDossierModal.vue?vue&type=script&lang=js&"
export * from "./SelectionTypeDossierModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports